<div class="page" *ngIf="orderData">
	<app-page-header header="Order details for order #{{ orderData?.display_id }}">
		<div *ngIf="orderData.is_pre_order == '1'" class="px-4 py-1 text-lg font-extrabold text-white bg-red-400 rounded-md">
			This is Pre order
		</div>
		<button type="button" pButton *ngIf="(orderData.order_payment_method == '3' || orderData.order_payment_method == '4') && orderData.payment_status != 'COMPLETED'"
				(click)="updatePaymentStatus()">
			Approve Payment
		</button>
	</app-page-header>

	<div class="add-product-container" *ngIf="orderData">
		<div class="py-2 border-b border-gray-300">
			<h2 class="pt-2 text-xl font-semibold">Order Details</h2>
			<div class="mt-2">
				<div class="detail-fields">
					<p>Order#:</p>
					<p>{{orderData.display_id}}</p>
				</div>
				<div class="detail-fields">
					<p>Order Subtotal:</p>
					<p>{{ orderData.subtotal | currency : orderData.order_currency }}</p>
				</div>
				<div class="detail-fields">
					<p>Shipping Charge:</p>
					<p>{{ orderData.shipping_charge | currency : orderData.order_currency }}</p>
				</div>
				<div class="detail-fields">
					<p>Tax:</p>
					<p>{{ orderData.tax | currency : orderData.order_currency}} </p>
				</div>
				<div class="detail-fields">
					<p>Order Discount:</p>
					<p>{{ orderData.discount | currency : orderData.order_currency}}</p>
				</div>
				<div class="detail-fields">
					<p>Order Total:</p>
					<p>{{ orderData.total | currency : orderData.order_currency}}</p>
				</div>
				<div class="detail-fields">
					<p>Transaction Id:</p>
					<p>{{ orderData.payment_id }}</p>
				</div>
				<div class="detail-fields">
					<p>Order Status:</p>
					<p class="bg-yellow-400 py-1 px-4 rounded-md text-white min-w-[80px] max-w-min text-center">
						{{ orderData.status }}
					</p>
				</div>
				<div class="detail-fields">
					<p>Payment Status:</p>
					<p class="bg-yellow-400 py-1 px-4 rounded-md text-white min-w-[80px] max-w-min text-center">
						{{ orderData.payment_status }}
					</p>
				</div>
				<div class="detail-fields">
					<p>Pre Order:</p>
					<p class="bg-blue-400 py-1 px-4 rounded-md text-white min-w-[80px] max-w-min text-center">
						{{ orderData.is_pre_order == '1' ? 'Yes' : 'No' }}
					</p>
				</div>
			</div>
		</div>

		<div class="py-2">
			<div class="flex">
				<div class="w-full">
					<div class="flex items-center justify-between">
						<h2 class="pt-2 pb-1 text-xl font-semibold">Order Products</h2>
					</div>
					<app-simple-table [columns]="orderItemsColumns" [data]="orderItems" [paginator]="true" [showFilter]="false" [showActions]="false" />
				</div>
			</div>
		</div>

		<div class="py-2 border-b border-gray-300">
			<div class="flex">
				<div class="w-full pr-12 border-r border-gray-300">
					<div class="flex items-center justify-between">
						<h2 class="pt-2 pb-1 text-xl font-semibold">Order Shipping Address</h2>
					</div>

					<div class="detail-fields">
						<p>Address 1:</p>
						<p>{{ orderData.order_shipping_address.address_1 }}</p>
					</div>

					<div class="detail-fields">
						<p>Address-2:</p>
						<p>{{ orderData.order_shipping_address.address_2 }}</p>
					</div>

					<div class="detail-fields">
						<p>City:</p>
						<p>{{ orderData.order_shipping_address.city }}</p>
					</div>

					<div class="detail-fields">
						<p>State:</p>
						<p>{{ orderData.order_shipping_address.state }}</p>
					</div>

					<div class="detail-fields">
						<p>Country:</p>
						<p>{{ orderData.order_shipping_address.country }}</p>
					</div>

					<div class="detail-fields">
						<p>landmark:</p>
						<p>{{ orderData.order_shipping_address.landmark }}</p>
					</div>
				</div>

				<div class="w-full pl-8">
					<div class="flex items-center justify-between">
						<h2 class="pt-2 pb-1 text-xl font-semibold">Order Billing Address</h2>
					</div>

					<div class="detail-fields">
						<p>Address 1:</p>
						<p>{{ orderData.order_billing_address.address_1 }}</p>
					</div>

					<div class="detail-fields">
						<p>Address-2:</p>
						<p>{{ orderData.order_billing_address.address_2 }}</p>
					</div>

					<div class="detail-fields">
						<p>City:</p>
						<p>{{ orderData.order_billing_address.city }}</p>
					</div>

					<div class="detail-fields">
						<p>State:</p>
						<p>{{ orderData.order_billing_address.state }}</p>
					</div>

					<div class="detail-fields">
						<p>Country:</p>
						<p>{{ orderData.order_billing_address.country }}</p>
					</div>

					<div class="detail-fields">
						<p>landmark:</p>
						<p>{{ orderData.order_billing_address.landmark }}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="w-full py-2 border-b border-gray-300">
			<div class="flex items-center justify-between">
				<h2 class="pt-2 pb-1 text-xl font-semibold">User Details</h2>
			</div>
			<div class="detail-fields">
				<p>User name:</p>
				<p>{{ orderData.first_name }} {{ orderData.last_name }}</p>
			</div>

			<div class="detail-fields">
				<p>Email:</p>
				<p class="underline">
					<a href="mailto:{{ orderData.email }}">
						{{ orderData.email }}
					</a>
				</p>
			</div>

			<div class="detail-fields">
				<p>Phone:</p>
				<p class="underline">
					<a href="tel:{{ orderData.mobile }}
			  {{ orderData.mobile }}">
						{{ orderData.mobile }}</a>
				</p>
			</div>

			<div class="detail-fields">
				<p>Ordered On:</p>
				<p>{{ orderData.created_at | date : 'medium' }}</p>
			</div>
		</div>
	</div>
</div>